"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var dialog_1 = require("../../../../components/pricing/layout/dialog/dialog");

var output_field_1 = require("../../../../components/pricing/text/output-field/output-field");

var constants_1 = require("../../../../theming/pricing-system/constants");

var pharmacy_edit_dialog_content_1 = require("../../../../theming/pricing-system/pharmacy-edit-dialog.content");

var theme_1 = require("../../../../theming/theme");

var password_generate_warning_prompt_1 = require("../../prompts/password-generate-warning-prompt/password-generate-warning-prompt");

var PharmacyEditDialog = function (_super) {
  __extends(PharmacyEditDialog, _super);

  function PharmacyEditDialog() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {};

    _this.onPasswordGenerate = function () {
      _this.setState({
        doConfirmation: true
      });
    };

    _this.onPasswordGenerateConfirmed = function () {
      _this.setState({
        doConfirmation: false
      });

      var onPasswordGenerate = _this.props.onPasswordGenerate;

      if (onPasswordGenerate) {
        onPasswordGenerate(_this.props.pharmacyUserOid);
      }
    };

    _this.onPasswordGenerateCancelled = function () {
      _this.setState({
        doConfirmation: false
      });
    };

    return _this;
  }

  PharmacyEditDialog.prototype.render = function () {
    var buttons = [{
      onPress: this.onPasswordGenerate,
      text: pharmacy_edit_dialog_content_1.PharmacyEditDialogContent.passwordGenerateButtonText
    }, {
      onPress: this.props.onClose,
      text: pharmacy_edit_dialog_content_1.PharmacyEditDialogContent.closeButtonText,
      type: 'close'
    }];
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(dialog_1.Dialog, {
      title: pharmacy_edit_dialog_content_1.PharmacyEditDialogContent.title,
      viewStyle: this.props.viewStyle,
      buttons: buttons
    }, react_1.default.createElement(output_field_1.OutputField, {
      label: pharmacy_edit_dialog_content_1.PharmacyEditDialogContent.pharmacyNameLabel,
      value: this.props.pharmacyName,
      allowWrap: true
    }), react_1.default.createElement(output_field_1.OutputField, {
      label: pharmacy_edit_dialog_content_1.PharmacyEditDialogContent.pharmacyNcpdpLabel,
      value: this.props.pharmacyNcpdp
    }), react_1.default.createElement(output_field_1.OutputField, {
      label: pharmacy_edit_dialog_content_1.PharmacyEditDialogContent.userLoginLabel,
      value: this.props.emailAddress
    }), this.renderPassword()), this.renderPasswordGenerateWarningPrompt());
  };

  PharmacyEditDialog.prototype.renderPassword = function () {
    var password = this.props.pharmacyPassword || constants_1.passwordPlaceholder;
    var isPasswordPlaceholder = !this.props.pharmacyPassword;
    var color = isPasswordPlaceholder ? undefined : theme_1.GreenScale.darkest;
    return react_1.default.createElement(output_field_1.OutputField, {
      label: pharmacy_edit_dialog_content_1.PharmacyEditDialogContent.passwordLabel,
      color: color,
      value: password,
      isAnimated: true,
      isImportant: !isPasswordPlaceholder
    });
  };

  PharmacyEditDialog.prototype.renderPasswordGenerateWarningPrompt = function () {
    if (!this.state.doConfirmation) {
      return null;
    }

    return react_1.default.createElement(password_generate_warning_prompt_1.PasswordGenerateWarningPrompt, {
      onCanceled: this.onPasswordGenerateCancelled,
      onConfirmed: this.onPasswordGenerateConfirmed
    });
  };

  return PharmacyEditDialog;
}(react_1.default.Component);

exports.PharmacyEditDialog = PharmacyEditDialog;